import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const LiveMapPage = lazyWithRetry(() => import("./LiveMapPage"));

export default [
  <Route exact path="/map/live" key="gps-live-map" component={LiveMapPage} />,
];
